import { render, staticRenderFns } from "./BindCustomersHeader.vue?vue&type=template&id=e9ddde08&scoped=true&"
import script from "./BindCustomersHeader.vue?vue&type=script&lang=ts&"
export * from "./BindCustomersHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BindCustomersHeader.vue?vue&type=style&index=0&id=e9ddde08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ddde08",
  null
  
)

export default component.exports